import React, { useState } from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';
import Input from './ui/Input';
import promocodeService from '../utils/promocodeService';

const PromocodeRedeem = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setMessage('Please enter a promocode');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const result = await promocodeService.redeemPromocode(code.trim());
      
      if (result.success) {
        setMessage(result.message);
        setMessageType('success');
        setCode(''); // Clear the input
      } else {
        setMessage(result.error);
        setMessageType('error');
      }
    } catch (error) {
      setMessage('Failed to redeem promocode. Please try again.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Promocode Header */}
      <div>
        <h2 className="text-xl font-semibold text-text-primary">Promocode Redemption</h2>
        <p className="text-sm text-text-secondary mt-1">
          Enter your promocode to redeem credits and enhance your email validation capabilities
        </p>
      </div>

      {/* Promocode Form */}
      <div className="card p-6">
        <h3 className="text-lg font-medium text-text-primary mb-4">Redeem Promocode</h3>
        
        <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Promocode
            </label>
            <Input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="Enter your promocode"
              disabled={loading}
            />
          </div>

          <Button
            type="submit"
            variant="primary"
            disabled={loading || !code.trim()}
            loading={loading}
            iconName="Gift"
            iconPosition="left"
            fullWidth
            animation="pulse"
          >
            {loading ? 'Redeeming...' : 'Redeem Promocode'}
          </Button>
        </form>

        {message && (
          <div className={`mt-4 p-3 rounded-md ${
            messageType === 'success' 
              ? 'bg-success/10 text-success border border-success/20' 
              : 'bg-error/10 text-error border border-error/20'
          }`}>
            <div className="flex items-center space-x-2">
              <Icon 
                name={messageType === 'success' ? 'CheckCircle' : 'AlertCircle'} 
                size={16} 
                className="flex-shrink-0"
              />
              <span className="text-sm font-medium">{message}</span>
            </div>
          </div>
        )}

        <div className="mt-6 p-4 bg-blue-50 rounded-md">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} className="text-blue-600 mt-0.5 flex-shrink-0" />
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-2">Important Information:</p>
              <ul className="space-y-1 text-xs">
                <li>• You can use multiple promocodes per account</li>
                <li>• Only one promocode can be redeemed at a time</li>
                <li>• Credits are added to your account immediately upon successful redemption</li>
                <li>• Promocodes are case-insensitive</li>
                <li>• Contact support if you encounter any issues</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromocodeRedeem;
